module.exports = __webpack_public_path__ + "static/media/product4.01bf69f6.png";